import React, { useMemo } from 'react';

import { SEGMENT_ANON_ID } from '../constants/forms';

const useSegmentAnonId = () => {
  const getSegmentAnonId = () => document.getElementById(SEGMENT_ANON_ID)?.value || '';

  const SegmentAnonIdInput = useMemo(
    () => () => <input id={SEGMENT_ANON_ID} name={SEGMENT_ANON_ID} type="hidden" />,
    []
  );

  return {
    getSegmentAnonId,
    SegmentAnonIdInput,
  };
};

export default useSegmentAnonId;
